import EcoSectionCommon from 'eco-design/elements/eco-section-common';
import styles from './index.module.scss';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';

const ZeroBills: React.FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('zero_bills');

    const items = [
        {
            title: t('item1_title'),
            desc: t('item1_desc'),
            text: t('item1_bar'),
            text2: '',
        },
        {
            title: t('item2_title'),
            desc: t('item2_desc'),
            text: t('item2_bar'),
            text2: t('item2_bar2'),
            textH5: t('item2_bar3'),
            text2H5: t('item2_bar4'),
        },
    ];

    return (
        <div className={styles.ZeroBills}>
            {locale === 'uk' ? (
                <EcoSectionCommon
                    desc={t('desc2')}
                    label={t('label')}
                    title={t.rich('title2', {
                        color: (chunks: string) => <span className="color">{chunks}</span>,
                    })}
                />
            ) : (
                <EcoSectionCommon
                    desc={t('desc')}
                    label={t('label')}
                    title={t.rich('title', {
                        color: (chunks: string) => <span className="color">{chunks}</span>,
                    })}
                />
            )}
            <div className="box">
                <div className="top">
                    <EcoImg
                        pc="https://websiteoss.ecoflow.com/upload/image/1748485763360/pc%20(1).jpg"
                        pad="https://websiteoss.ecoflow.com/upload/image/1748485754308/m%20(1).jpg"
                        h5="https://websiteoss.ecoflow.com/upload/image/1748486139229/h5.jpg"
                    />
                </div>
                {locale !== 'uk' && (
                    <div className="center-title">
                        <div className="title">
                            {t.rich('title2', {
                                color: (chunks: string) => <span className="color">{chunks}</span>,
                            })}
                        </div>
                        <div className="desc">{t('desc2')}</div>
                    </div>
                )}
                <div className="bottom">
                    {items.map((item, index) => {
                        return (
                            <div className="bottom-row" key={index}>
                                <div className="bottom-t-title">{item.title}</div>
                                <div className="bottom-t-desc">{item.desc}</div>
                                <div className="bottom-t-bar">
                                    <div className={'progress progress_' + (index + 1)}></div>
                                    <div className={'progress-text'}>
                                        {index === 0 && <span>{item.text}</span>}
                                        {index === 1 && (
                                            <>
                                                <span className="pc">{item.text}</span>
                                                <span className="pc progress2-text">{item.text2}</span>
                                                <div className="h5">{item.textH5}</div>
                                                <div className="h5 progress2-text">{item.text2H5}</div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                    <div className="type-box">
                        <div className="row row-1">
                            <div className="stuck"></div>
                            <div className="text">{t('item2_bar')}</div>
                        </div>
                        <div className="row row-2">
                            <div className="stuck"></div>
                            <div className="text">{t('item2_bar2')}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ZeroBills;
